import { Controller } from 'stimulus';

import Sortable from 'sortable/js/sortable';

import 'sortable/css/sortable-theme-minimal';

export default class extends Controller {
  connect() {
    let table = this.element;

    table.setAttribute('data-sortable', '');
    table.classList.add('sortable-theme-minimal');
    Sortable.initTable(table)
  }
}
